import React from 'react'
import { Navigate, Route, Routes, Outlet } from 'react-router-dom'
import { PageLink, PageTitle } from '../../../_metronic/layout/core'
import CouponPage from './components/coupon/CouponPage'
import OfferPage from './components/Offer/OfferPage'
import ClientWalletPage from './components/client-wallet/ClientWalletPage'
import TransactionPage from './components/transaction/TransactionPage'
import GiftGalleryPage from './components/gift-gallery/GiftGalleryPage'
import CataloguePage from './components/Catalogue/CataloguePage'
import ClientPage from './components/Client/ClientPage'
import PendingTable from './components/transaction/components/PendingTable/PendingTable'
import RejectedTable from './components/transaction/components/RejectedTable/RejectedTable'
import ApprovedTable from './components/transaction/components/ApprovedTable/ApprovedTable'
import DealerPriceListPage from './components/DealerPriceList/DealerPriceListPage'
import DealerSchemePage from './components/DealerScheme/DealerSchemePage'
import ProductPage from './components/product/ProductPage'
import ReportPage from './components/Report/ReportPage'

export function nameReturn(empDetails: any) {
  const fullName = [
    empDetails?.title,
    empDetails?.first_name,
    empDetails?.middle_name,
    empDetails?.last_name,
  ]
    .filter(Boolean) // Filters out any null, undefined, or empty strings
    .join(' ')

  return fullName
}

const CrmPage: React.FC = () => {
  return (
    <Routes>
      <Route element={<Outlet />}>
        <Route
          path='coupon/*'
          element={
            <>
              <CouponPage />
            </>
          }
        />
        <Route
          path='offer/*'
          element={
            <>
              <OfferPage />
            </>
          }
        />
        <Route
          path='client/*'
          element={
            <>
              <ClientPage />
            </>
          }
        />
        <Route
          path='gift-gallery/*'
          element={
            <>
              <GiftGalleryPage />
            </>
          }
        />
        <Route
          path='client-wallet/*'
          element={
            <>
              <ClientWalletPage />
            </>
          }
        />
        <Route
          path='transaction/*'
          element={
            <>
              <TransactionPage />
            </>
          }
        />
        <Route
          path='pending-transaction/*'
          element={
            <>
              <PendingTable />
            </>
          }
        />
        <Route
          path='rejected-transaction/*'
          element={
            <>
              <RejectedTable />
            </>
          }
        />
        <Route
          path='approved-transaction/*'
          element={
            <>
              <ApprovedTable />
            </>
          }
        />
        <Route
          path='catalogue/*'
          element={
            <>
              <CataloguePage />
            </>
          }
        />
        <Route
          path='dealer-price-lists/*'
          element={
            <>
              <DealerPriceListPage />
            </>
          }
        />
        <Route
          path='dealer-schemes/*'
          element={
            <>
              <DealerSchemePage />
            </>
          }
        />
        <Route
          path='product/*'
          element={
            <>
              <ProductPage />
            </>
          }
        />
        <Route
          path='report/*'
          element={
            <>
              <ReportPage />
            </>
          }
        />
      </Route>
      <Route path='/crm/*' element={<Navigate to='/error/404' />} />
    </Routes>
  )
}

export default CrmPage
